export default __webpack_public_path__ + "static/testimonial-user-4-5a51333edce88027128526b15fc231e8.jpg";